import React from "react";
import PropTypes from "prop-types";
// Material imports
import MUIDataTable from "mui-datatables";
//Limitless imports
import Paper from "@limitless/modern/surfaces/paper/Paper";
import Pagination from "./Pagination";
const DataTable = ({
  title,
  data,
  columns,
  option,
  tableRefreshFunc,
  loadmore = false
}) => {
  const PageSize = 10;
  const [currentPage, setCurrentPage] = React.useState(1);
  const currentTableData = React.useMemo(() => {
    const firstPageIndex = (data.length <= PageSize ? 0 : currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, data]);
  React.useEffect(() => {
    setCurrentPage(1);
  }, [tableRefreshFunc]);
  const TABLE_OPTIONS = {
    filter: false,
    search: false,
    responsive: "standard",
    selectableRows: "none",
    Pagination: false,
    print: false,
    viewColumns: false,
    download: false,
    customFooter: () => {
      return /*#__PURE__*/React.createElement(Pagination, {
        className: "pagination-bar",
        currentPage: currentPage,
        totalCount: data.length,
        loadMore: loadmore,
        pageSize: PageSize,
        tableRefreshFunc: tableRefreshFunc,
        onPageChange: page => setCurrentPage(page)
      });
    },
    ...option
  };
  return /*#__PURE__*/React.createElement(Paper, {
    sx: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(MUIDataTable, {
    title: title,
    data: currentTableData,
    columns: columns,
    options: TABLE_OPTIONS
  }), " ");
};
export default DataTable;
DataTable.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  option: PropTypes.object,
  loadmore: PropTypes.bool,
  tableRefreshFunc: PropTypes.func
};